import React from 'react';
import cls from 'classnames';
import './From.scss';

/**
 * @param {object} props
 * @param {boolean} checked
 * @param {boolean} disabled
 */

function CusCheckboxOne({
  checked,
  value,
  disable,
  onChange = () => { },
  ...props
}) {
  return (
    <div className="CusCheckboxOne d-inline-flex align-items-center w-auto">
      <label className={cls('CusCheckboxLabel d-flex flex-shrink-0',
        checked ? 'checked' : '')}>
        <input
          type="checkbox"
          checked={checked}
          style={{ display: 'none' }}
          onChange={onChange}
        />
      </label>
      <span className={cls('text-justify CusCheckboxOneText',
        checked ? 'checked' : '')}
        onClick={onChange}><span>{value}</span></span>
    </div>
  );
}

export { CusCheckboxOne };
